module.exports.Model = require("./model");
module.exports.Collection = require("./collection");
module.exports.Events = require("backbone-events-standalone");
module.exports.extend = require("backbone-extend-standalone");



// WEBPACK FOOTER //
// ./~/backbone-thin/index.js